import gql from 'graphql-tag'

export const ORGANISATION_APPLE_WALLET_QUERY = gql`
query OrganisationAppleWalletSettings {
  organisationAppleWalletSettings {
    result {
      id
      logo
      logoHeight
      logoWidth
    }
  }
}
`